/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

const { scrollToAnchor } = require("./src/utils/scrollToAnchor")

// Gatsby's built-in scroll restoration (gatsby-react-router-scroll) scrolls to
// hash targets on its own via a plain `node.scrollIntoView()` with no offset,
// and only accepts `true`, `false`, or an `[x, y]` pair as a return value —
// anything else (e.g. a truthy string) gets treated like `true` and runs its
// own un-offset scrollIntoView, racing our offset-aware scrollToAnchor below.
// onRouteUpdate/header.js's scrollToAnchor calls are the single scroll
// mechanism for hash navigation, so always disable Gatsby's own restore when
// a hash is present, and let it handle plain [x, y] restoration otherwise.
exports.shouldUpdateScroll = ({ prevRouterProps, routerProps: { location } }) => {
  const { pathname, hash } = location

  if (hash) {
    return false
  }

  if (prevRouterProps) {
    const { location: { pathname: oldPathname } } = prevRouterProps
    if (oldPathname === pathname) {
      return [0, 0]
    }
  }

  return true
}

exports.onRouteUpdate = ({ location }) => {
  if (!location.hash) return

  scrollToAnchor(decodeURIComponent(location.hash.replace("#", "")))
}